import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { isClientPreview } from "../../../utils/clientPreview";

import loader from "../../../assets/img/loader.gif"

const Notification = lazy(() => import("../pages/notification"));

// Old pages that are not in the menu: the client preview sends direct links to the dashboard.
const hidden = (page) => (isClientPreview() ? <Navigate to="/customer/dashboard" replace /> : page);
const Settings = lazy(() => import("../pages/settings"));
const TrackingPage = lazy(() => import("../pages/tracking-page"));
const Order = lazy(() => import("../pages/orders"));
const ProductDetailsNew = lazy(() =>
  import("../pages/products/product_details/ProductDetailsNew")
);
const LiveProducts = lazy(() => import("../pages/products/live_products/"));
const QualityCheck = lazy(() => import("../pages/products/quality_check"));
const EditImportProduct = lazy(() =>
  import("../pages/products/import_list/EditImportProduct/indes")
);
const ImportList = lazy(() => import("../pages/products/import_list"));
const Branding = lazy(() => import("../pages/products/branding"));
const Product = lazy(() => import("../pages/products"));
const Payment = lazy(() => import("../pages/payments"));
const OrderTracking = lazy(() => import("../pages/orders/order_tracking"));
const DisputeList = lazy(() => import("../pages/orders/dispute_list"));
const ReturnedOverseas = lazy(() => import("../pages/orders/returned-overseas"));
const ExtraStorage = lazy(() => import("../pages/extra_storage"));
const CustomerPrivateOutlet = lazy(() =>
  import("../components/CustomerPrivateOutlet")
);
const Dashboard = lazy(() => import("../pages/dashboard"));
const FinalizePurchaseStepper = lazy(() =>
  import("../pages/bulk_purchase/components/FinalizePurchaseStepper")
);


export default function CustomerRoutes() {
  return (
    <Suspense
      fallback={
        <div
          style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background:"#fff"
          }}
        >
          <img src={loader} alt="loader" style={{width:"200px", height:"200px", objectFit:"contain"}}/>
        </div>
      }
    >
      <Routes>
        <Route path="/customer/*" element={<CustomerPrivateOutlet />}>
          <Route path="" element={<Navigate to="dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="products" element={<Product />} />
          <Route path="stepper" element={hidden(<FinalizePurchaseStepper />)} />
          <Route path="products/:id" element={<ProductDetailsNew />} />
          <Route path="products/live-products" element={<LiveProducts />} />
          <Route path="products/quality-check" element={<QualityCheck />} />
          <Route path="products/import-list" element={hidden(<ImportList />)} />
          <Route
            path="products/import-list/product/:id"
            element={hidden(<EditImportProduct />)}
          />
          <Route path="orders" element={<Order />} />
          <Route path="orders/dispute-list" element={<DisputeList />} />
          <Route path="orders/order-tracking" element={<OrderTracking />} />
          <Route path="orders/returned-to-overseas-warehouse" element={<ReturnedOverseas />} />
          <Route path="payments" element={<Payment />} />
          <Route path="notifications" element={<Notification />} />
          <Route path="extra" element={hidden(<ExtraStorage />)} />
          <Route path="extra/branding" element={hidden(<Branding />)} />
          <Route path="setting" element={<Settings />} />
          <Route path="tracking-page" element={<TrackingPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
